import React from 'react';
import { observer } from 'mobx-react';

import '../css/StudentAssignmentDetailsPopup.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import PopupService from '../services/PopupService';

const StudentAssignmentDetailsPopup = observer((props) => {
  const {
    assignment,
    popupOptions = {},
    showDateAssigned = true,
    showDueDate = true,
    showDueTime = true,
    showSubmitted = true,
    t,
    timezoneAbbreviation
  } = props;
  const { trigger, ...restPopupOptions } = popupOptions;

  if (!assignment) {
    return null;
  }

  const renderRow = (labelKey, value) => {
    return (
      <div className='student-assignment-details-popup-row'>
        <span className='student-assignment-details-popup-row-label'>{t(labelKey)}</span>
        <span className='student-assignment-details-popup-row-value'>{value}</span>
      </div>
    );
  };

  const content = (
    <div className='student-assignment-details-popup-content'>
      {showDateAssigned && renderRow('dateAssigned', assignment.timezoneStartDate)}
      {showDueDate && renderRow('dueDate', assignment.timezoneEndDate)}
      {showDueTime && renderRow('dueTime', [assignment.timezoneEndTime, timezoneAbbreviation].filter((part) => !!part).join(' '))}
      {showSubmitted && !!assignment.submitted && renderRow('submittedLabel', assignment.submittedDate)}
    </div>
  );

  return PopupService.renderPopup({
    className: 'custom-popup student-assignment-details-popup',
    on: 'click',
    position: 'bottom center',
    trigger,
    ...restPopupOptions,
    // eslint-disable-next-line sort-keys
    content
  });
});
export default StudentAssignmentDetailsPopup;

SatCoreRegister('StudentAssignmentDetailsPopup', StudentAssignmentDetailsPopup);
